export default __webpack_public_path__ + "connect-jira-with-shake.jpg";